import styled from "@emotion/styled";
import Banner from "component/banner/Banner";
import DisplayType from "utils/displayType";
import DefaultButton from "admin/component/button/DefaultButton";
import React, { useLayoutEffect } from "react";
import { updateTitle } from "utils/commonUtil";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import Footer from "../../component/footer/Footer";
import aboutContents from "../../assets/about_img.png";
import { ReactComponent as Logo } from "../../assets/new_logo.svg";
import aboutBanner from "../../assets/about_1440.jpg";
import aboutBanner1920 from "../../assets/about_1920.jpg";
import aboutBanner2048 from "../../assets/about_2048.jpg";

const AboutBluePoint = () => {
  const mode = DisplayType();
  const { language, t } = useLanguage();

  useLayoutEffect(() => {
    updateTitle(t("about", "pageTitle"));
  }, [t]);

  return (
    <Container>
      <Banner
        bannerImg={aboutBanner}
        bannerImg1920={aboutBanner1920}
        bannerImg2048={aboutBanner2048}
        mode={mode}
        imgPostiion={"right"}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: mode === "Mobile" ? "center" : "flex-start",
          }}
        >
          <div
            className={`${
              mode === "Mobile" ? "font-title-en" : "font-title-en"
            }`}
            style={{ color: "var(--white)", textTransform: "uppercase" }}
          >
            About
          </div>
          <div
            className={mode === "Mobile" ? "font-body3" : "font-body1"}
            style={{
              color: "var(--white)",
              marginTop: 24,
              textAlign: mode === "Mobile" ? "center" : "start",
            }}
          >
            {renderText(t("about", "bannerSubtitle"))}
          </div>
        </div>
      </Banner>
      <AboutContainer className="limit__body">
        <AboutSection>
          <div
            className={`about__section__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
            }`}
          >
            What We Do
          </div>
          <div
            className={`about__section__sub__title ${
              mode === "Mobile" ? "font-sub-title3" : "font-sub-title"
            } `}
          >
            {t("about", "whatWeDo.subtitle")}
          </div>
          <p className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}>
            {t("about", "whatWeDo.desc1")}
            {mode !== "Mobile" && <br />} {t("about", "whatWeDo.desc1_2")}
            {mode === "Mobile" && <br />}
            {mode === "Mobile" && <br />}
            {mode !== "Mobile" && <br />} {t("about", "whatWeDo.desc1_3")}
          </p>
          <p className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}>
            {t("about", "whatWeDo.desc2")}
            <br />
            {mode === "Mobile" && <br />} {t("about", "whatWeDo.desc2_2")}
          </p>
        </AboutSection>
        <AboutSection>
          <div
            className={`about__section__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
            }`}
          >
            Value Add
          </div>
          <div
            className={`about__section__sub__title ${
              mode === "Mobile" ? "font-sub-title3" : "font-sub-title"
            } `}
          >
            {t("about", "valueAdd.subtitle")}
          </div>

          <p className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}>
            {t("about", "valueAdd.desc1")}
            {mode !== "Mobile" && <br />} {t("about", "valueAdd.desc1_2")}
            {mode === "Mobile" && <br />}
            {mode === "Mobile" && <br />}
            {mode !== "Mobile" && <br />} {t("about", "valueAdd.desc2")}
            {mode !== "Mobile" && <br />}
            {mode !== "Mobile" && <br />}
            {t("about", "valueAdd.desc2_2")} {mode !== "Mobile" && <br />}
            {t("about", "valueAdd.desc2_3")} {mode === "Mobile" && <br />}
            {mode === "Mobile" && <br />}
            {mode !== "Mobile" && <br />}
            {t("about", "valueAdd.desc3")} {mode !== "Mobile" && <br />}
            {t("about", "valueAdd.desc3_2")}
          </p>

          {/* <BubbleMesesageContainer>
            <BubbleMessage
              className={`bubble__1 ${
                mode === "Mobile" ? "font-small-text" : "font-body3"
              }`}
            >
              내 기술과 시장성을 검증받고 싶은데 누가 해줄 수 있지?
            </BubbleMessage>
            <BubbleMessage
              className={`bubble__2 ${
                mode === "Mobile" ? "font-small-text" : "font-body3"
              }`}
            >
              CFO와 디자이너가 필요한데 안 구해져. 팀원을 어떻게 구하지?
            </BubbleMessage>
            <BubbleMessage
              className={`bubble__3 ${
                mode === "Mobile" ? "font-small-text" : "font-body3"
              }`}
            >
              후속투자 유치를 받아야 하는데 좋은 투자사를 소개받고 싶어!
            </BubbleMessage>
          </BubbleMesesageContainer> */}
        </AboutSection>
        <AboutSection>
          <a
            href={
              language === "en"
                ? "/pdf/Bluepoint_Company_Profile_ENG_2503.pdf"
                : "https://bluebox-ac.s3.ap-northeast-2.amazonaws.com/bbox/ci/Bluepoint_brandbook.pdf"
            }
            target={"_blank"}
            rel="noreferrer"
          >
            <DefaultButton className="font-body3" type="outline" height={42}>
              {t("about", "downloadBrochure")}
            </DefaultButton>
          </a>
        </AboutSection>
      </AboutContainer>
      <AboutImageContainer imgUrl={aboutContents}>
        <div className="overlay" />
        <div className="limit__body contents__container">
          <div
            className={`${
              mode === "Mobile" ? "font-sub-title2-en" : "font-title"
            }`}
            style={{ textTransform: "uppercase" }}
          >
            Philosophy
          </div>
          <div
            className={`${
              mode === "Mobile" ? "font-sub-title4" : "font-bold-28"
            }`}
            style={{ marginTop: mode === "Mobile" ? 32 : 40 }}
          >
            {renderText(t("about", "philosophy.title"), mode)}
          </div>
          <div style={{ marginTop: mode === "Mobile" ? 16 : 24 }}>
            <p
              className={`${mode === "Mobile" ? "font-body4" : "font-body2"}`}
              style={{ margin: 0 }}
            >
              {renderText(t("about", "philosophy.desc"))}
            </p>
          </div>
        </div>
      </AboutImageContainer>
      <AboutContainer className="limit__body">
        <AboutSection>
          <div
            className={`about__section__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
            }`}
          >
            Corporate Identity
            <CIDownload>
              <div className="ci__thumbnail__container">
                <Logo width={180} height={90} />
              </div>
              <div className="ci__description__container">
                <div
                  className={`${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{ color: "var(--grey-60)" }}
                >
                  {t("about", "ci.desc")}
                  <br />
                  <div style={{ marginBottom: 7 }} />
                  {t("about", "ci.desc2")}
                </div>
                <a
                  href="https://bluebox-ac.s3.ap-northeast-2.amazonaws.com/bbox/ci/Bluepoint+BI_RGB.ai"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <DefaultButton
                    className="font-body3"
                    type="outline"
                    height={42}
                  >
                    {t("about", "ci.download")}
                  </DefaultButton>
                </a>
              </div>
            </CIDownload>
          </div>
        </AboutSection>
      </AboutContainer>
      <Footer />
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 768px) {
  }
`;

const AboutContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const AboutSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .about__section__title {
    color: var(--black);
    text-transform: uppercase;
  }

  .about__section__sub__title {
    color: var(--primary);
    margin-top: 40px;
    margin-bottom: 16px;
  }

  p {
    color: var(--grey-60);
  }

  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .about__section__sub__title {
      margin-top: 24px;
    }
  }
`;

const BubbleMesesageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .bubble__1 {
    position: absolute;
    top: 24px;
    left: 0;
    :after {
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      bottom: -10px;
      left: 37px;
      border: 20px solid transparent;
      border-top-width: 0;
      border-bottom-color: var(--secondary-3);
      transform: rotate(-45deg);
    }
  }
  .bubble__2 {
    position: absolute;
    top: 83px;
    right: 36px;
    :after {
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      bottom: -10px;
      right: 37px;
      border: 20px solid transparent;
      border-top-width: 0;
      border-bottom-color: var(--secondary-3);
      transform: rotate(-45deg);
    }
  }
  .bubble__3 {
    position: absolute;
    top: 148px;
    left: 150px;
    :after {
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      bottom: -10px;
      right: 37px;
      border: 20px solid transparent;
      border-top-width: 0;
      border-bottom-color: var(--secondary-3);
      transform: rotate(-45deg);
    }
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    height: fit-content;
    gap: 24px;
    margin-bottom: 24px;
    .bubble__1 {
      position: relative;
      top: 0;
      left: 0;
      :after {
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        bottom: -10px;
        left: 37px;
        border: 12px solid transparent;
        border-top-width: 0;
        border-bottom-color: var(--secondary-3);
        transform: rotate(-45deg);
      }
    }
    .bubble__2 {
      position: relative;
      top: 0;
      left: 0;
      :after {
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        bottom: -10px;
        right: 37px;
        border: 12px solid transparent;
        border-top-width: 0;
        border-bottom-color: var(--secondary-3);
        transform: rotate(-45deg);
      }
    }
    .bubble__3 {
      position: relative;
      top: 0;
      left: 0;

      :after {
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        bottom: -10px;
        left: 37px;
        border: 12px solid transparent;
        border-top-width: 0;
        border-bottom-color: var(--secondary-3);
        transform: rotate(-45deg);
      }
    }
  }
`;

const BubbleMessage = styled.div`
  padding: 24px 40px;
  border-radius: 20px;
  background-color: var(--secondary-3);
  color: var(--primary);

  @media only screen and (max-width: 768px) {
    width: 100%;
    padding: 20px 16px;
    border-radius: 16px;
    text-align: center;
  }
`;

const AboutImageContainer = styled.div<{ imgUrl: string }>`
  position: relative;
  width: 100%;
  height: 800px;
  background-image: url(${(props) => props.imgUrl});
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .contents__container {
    display: flex;
    flex-direction: column;
    color: white;
    z-index: 2;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 80px;
    height: fit-content;
    padding-bottom: 20px;
    .contents__container {
      padding-top: 40px;
    }
  }
`;

const CIDownload = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-top: 40px;
  margin-bottom: 100px;

  .ci__thumbnail__container {
    width: 352px;
    min-width: 352px;
    max-width: 352px;

    height: 186px;
    min-height: 186px;
    max-height: 186px;

    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--grey-00);
  }

  .ci__description__container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;
    margin-bottom: 100px;

    .ci__thumbnail__container {
      width: 100%;
      min-width: 100%;
      max-width: 100%;

      height: 186px;
      min-height: 186px;
      max-height: 186px;

      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid var(--grey-00);
    }

    .ci__description__container {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }
`;
export default AboutBluePoint;
